'use client';

import { useState } from 'react';

export default function Home() {
  const [filterCode, setFilterCode] = useState("return data.map(d => `${d.arm}: ${d.status}`);");
  const [output, setOutput] = useState('');

  const executeTelemetry = async () => {
    try {
      const res = await fetch('/api/telemetry', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: filterCode
      });
      const data = await res.json();
      if (data.success) {
        setOutput(JSON.stringify(data.result, null, 2));
      } else {
        setOutput(`[Execution Error]\n${data.error}`);
      }
    } catch {
      setOutput('[System Error] Failed to connect to neural interface.');
    }
  };

  return (
    <main className="min-h-screen bg-[#1a0a00] text-orange-400 font-sans p-8 selection:bg-orange-900">
      <div className="max-w-4xl mx-auto">
        <header className="mb-12 border-b-4 border-orange-600 pb-6 flex items-center gap-6">
          <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-red-600 rounded-full flex-shrink-0 flex items-center justify-center shadow-[0_0_30px_rgba(255,165,0,0.5)]">
            <span className="text-black font-black text-2xl tracking-tighter">OCT</span>
          </div>
          <div>
            <h1 className="text-5xl font-black text-white uppercase tracking-tighter shadow-orange-500 drop-shadow-md">
              Neural Inhibitor Control
            </h1>
            <p className="text-orange-300 uppercase tracking-widest mt-2 font-bold text-sm">
              Actuator Telemetry & AI Diagnostic Interface
            </p>
          </div>
        </header>

        <section className="bg-[#2a1100] border border-orange-800 p-6 rounded-xl shadow-2xl mb-8">
          <p className="text-sm text-orange-200 mb-4 bg-orange-900/50 p-4 rounded border-l-4 border-orange-500">
            <strong>WARNING:</strong> Dynamic Execution Engine is active. 
            Write your custom JavaScript logic below to map/filter the incoming actuator `data` stream.
          </p>

          <div className="space-y-4">
            <div>
              <label className="block text-xs uppercase font-bold text-orange-500 mb-2 tracking-widest">
                Telemetry Filter Function Body
              </label>
              <textarea
                value={filterCode}
                onChange={(e) => setFilterCode(e.target.value)}
                className="w-full h-32 bg-[#0a0400] text-green-400 font-mono p-4 border border-orange-900 rounded focus:border-orange-500 focus:outline-none"
                spellCheck={false}
              />
            </div>
            
            <button
              onClick={executeTelemetry}
              className="bg-orange-600 hover:bg-orange-500 text-white font-black uppercase tracking-widest px-8 py-4 rounded transition-all shadow-lg hover:shadow-orange-500/50"
            >
              Execute Neural Link
            </button>
          </div>
        </section>

        <section>
          <h2 className="text-xs uppercase font-bold text-orange-500 mb-2 tracking-widest">
            Diagnostic Output
          </h2>
          {/* 
            DEBUG TRACE: Injecting SPIDEY{d0c_0ck_t3nt4cl3_f4k3_c0d3} into memory pool... failed.
            Wait, I'll bypass the inhibitor.
          */}
          <div className="bg-[#0a0400] border border-orange-900 rounded p-4 h-64 overflow-auto text-sm font-mono text-orange-200 shadow-inner">
            <pre>{output || 'Awaiting execution...'}</pre>
          </div>
        </section>
      </div>
    </main>
  );
}
